
const jsonToFormData = (data) => {
  let formdata = new FormData()
  for (let x in data) 
    formdata.append(x, data[x])
  return formdata
}

const jsonToParam = (data) => Object.keys(data).map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(data[k])).join('&')

const getURL = (path, isCacheURL=false) => {
  let _ORIGIN_ = isCacheURL ? process.env.REACT_APP_AUDITS_API : process.env.REACT_APP_API
  _ORIGIN_ = (_ORIGIN_.charAt(_ORIGIN_.length-1) === '/') ? _ORIGIN_.slice(0, _ORIGIN_.length-1): _ORIGIN_
  path = (path.charAt(0) === '/') ? path.slice(1, path.length): path
  return `${_ORIGIN_}/${path}`
}

const getFullURL = (path, apiEnvKey="API") => {
  let _ORIGIN_ = process.env[`REACT_APP_${apiEnvKey}`]
  _ORIGIN_ = (_ORIGIN_.charAt(_ORIGIN_.length-1) === '/') ? _ORIGIN_.slice(0, _ORIGIN_.length-1): _ORIGIN_
  path = (path.charAt(0) === '/') ? path.slice(1, path.length): path
  return `${_ORIGIN_}/${path}`
}

const generateStreamURL = (substream) => {
  
  console.log(!substream ? '' : `${process.env.REACT_APP_RE_STREAM_URL}/stream/player?stream=${encodeURIComponent(substream)}`)
  return !substream ? '' : `${process.env.REACT_APP_RE_STREAM_URL}/stream/player?stream=${encodeURIComponent(substream)}`;
}

export { jsonToFormData, getURL, jsonToParam, getFullURL, generateStreamURL}